import { store } from '~/store';
import { setUtmParams } from '~/store/slices/utm';

export interface UtmParams {
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_term?: string | null;
  fbclid?: string | null;
}

export function getUtmParamsFromUrl(): UtmParams {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_term: params.get('utm_term'),
    fbclid: params.get('fbclid'),
  };
}

/**
 * Store UTM parameters in Redux store
 * Only stores if at least one UTM parameter exists
 */
export function storeUtmParams(utmParams: UtmParams): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    // Only store if at least one UTM param exists
    if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign || utmParams.utm_term || utmParams.fbclid) {
      store.dispatch(setUtmParams(utmParams));
    }
  } catch (error) {
    console.error('Failed to store UTM parameters:', error);
  }
}

/**
 * Retrieve stored UTM parameters from Redux store
 */
export function getStoredUtmParams(): UtmParams {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const state = store.getState();
    return state.utm?.utmParams || {};
  } catch (error) {
    console.error('Failed to retrieve UTM parameters:', error);
    return {};
  }
}

export function initializeUtmTracking(): void {
  const urlUtmParams = getUtmParamsFromUrl();
  storeUtmParams(urlUtmParams);
}
